import { render, staticRenderFns } from "./AppMessages.vue?vue&type=template&id=2683951d&"
import script from "./AppMessages.vue?vue&type=script&lang=js&"
export * from "./AppMessages.vue?vue&type=script&lang=js&"
import style0 from "./AppMessages.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports